import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  constructor(private http: HttpClient) {}

  upload(file, link, header = null):Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<any>(`${link}`, formData, {
      headers: header
    })
  }
}
